import React from "react";
import PlansRadio from "../../../kit-components/Radio/Plans"
import Skeleton from 'react-loading-skeleton';
import styles from './payments-plans.module.scss';

export function PaymentsPlans(props) {
  const { tenureList, setPlan } = props;

  return (
    <div className={styles['form']}>
      {tenureList.length === 0 ? (
        <div className={styles['plans-skelton']}>
          {[1, 2, 3, 4].map(() => {
            return (
              <div className={styles['item']}>
                <Skeleton height={65} />
              </div>
            );
          })}
        </div>
      ) : (
        <PlansRadio
          plans={tenureList}
          onChange={(data) => setPlan(data)}
        />
      )}
    </div>
  );
}

export default PaymentsPlans;
